function applyCollectionColor() {
  const $grid = $("#CollectionProductGridAjaxWrapper");
  $grid.css("opacity", "0.3"); // dim grid while processing

  var collectionColor = $("#collection-color").data("collection-color");
  if (!collectionColor) {
    $grid.css("opacity", "1");
    return;
  }

  const colorChangePromises = [];

  $(".product-card").each(function () {
    var $card = $(this);

    // Find label matching the collection color
    var $colorLabel = $card.find("label.color-swatch").filter(function () {
      var colorName = $(this).data("color-name");
      return (
        colorName && colorName.toLowerCase() === collectionColor.toLowerCase()
      );
    });

    if ($colorLabel.length) {
      var inputId = $colorLabel.attr("for");
      var $input = $("#" + inputId);

      // Wrap the delayed click in a Promise so we can know when all are done
      const p = new Promise((resolve) => {
        setTimeout(function () {
          $input.trigger("click");
          resolve();
        }, 100); // adjustable delay
      });

      colorChangePromises.push(p);
    }
  });

  // Once all timeouts finished, show grid again
  Promise.all(colorChangePromises).then(() => {
    $grid.css("opacity", "1");
  });
}

document.addEventListener("click", function (event) {
  const link = event.target.closest(".pagination__item");
  if (!link || link.classList.contains("disabled")) return;

  event.preventDefault();

  const url = link.getAttribute("href");
  if (!url) return;

  const $grid = $("#CollectionProductGridAjaxWrapper");
  $grid.css("opacity", "0.3");

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newContent = doc.querySelector("#CollectionProductGridAjaxWrapper");
      const currentContent = document.querySelector(
        "#CollectionProductGridAjaxWrapper"
      );

      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
        currentContent.scrollIntoView({ behavior: "smooth" });

        const pageParam = new URL(url, window.location.origin).searchParams.get(
          "page"
        );
        console.warn("Navigated to page:", pageParam);
        document.querySelectorAll(".pagination__item").forEach((item) => {
          const itemPage = new URL(
            item.getAttribute("href"),
            window.location.origin
          ).searchParams.get("page");
          console.warn("Item page:", itemPage);
          if (pageParam && itemPage === pageParam) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });

        // ✅ Re-run color logic after pagination
        applyCollectionColor();
      } else {
        $grid.css("opacity", "1");
      }
    });
});

// ✅ Run on first load
$(document).ready(applyCollectionColor);
